import Skeleton from '@material-ui/lab/Skeleton';
import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { Route, Switch } from 'react-router-dom';
import Holidays from '../controls/wrappers/holidays/index';
import MasterTemplates from '../controls/wrappers/mastertemplate';
import Notice from '../controls/wrappers/notice';
import Settings from '../controls/wrappers/settings/settingscontainer';
import SidebarBr from '../controls/wrappers/sidebarbr';
import Billingconfiguration from '../controls/wrappers/billingconfiguration';
import Alert from '../core/controls/components/alert';
import ConfirmationDialog from '../core/controls/components/confirmationPopup';
import HelpContext from '../core/controls/components/helpContext';
import Loader from '../core/controls/components/loading';
import RecordEditor from '../core/controls/components/recordeditors';
import DefaultSettings from '../core/controls/components/settings';
import consultantgrid from '../json/consultant/consultantgrid';
//import Search from '../modules/search/index_tsp';
import AdvSearch from '../core/modules/search/advancedsearch';
import CompanyApprovals from '../core/wrappers/approvals';
import DashboardFlowIntegrations from '../core/modules/DashboardFlows';
const CreateRecord = lazy(() => import('../controls/wrappers/record/createrecord'));
const EditRecord = lazy(() => import('../controls/wrappers/record/editrecord'));
const CGrid = lazy(() => import('../core/modules/Grid/cgrid'));
const ProjectDownloads = lazy(() => import('../controls/wrappers/projectdownloads/projectdownloadscontainer'));
const Authorizations = lazy(() => import('../core/wrappers/authorizations'));
const RegistrationRequest = lazy(() => import('../core/wrappers/registrations'));
const SwitchWorkflow = lazy(() => import('../controls/wrappers/switchuser/switchusercontainer'));
const UserProcessFlows = lazy(() => import('../core/modules/ProcessFlows'));
const ProcessBuilder = lazy(() => import('../core/modules/ProcessBuilder'));
const ReportsBuilder = lazy(() => import('../core/modules/ReportsBuilder'));
const Integrations = lazy(() => import('../core/modules/ComponentBuilder'));
const FormBuilder = lazy(() => import('../core/modules/FormBuilder'));
const DashboardBuilder = lazy(() => import('../core/modules/DashboardBuilder'));
const MapSegments = lazy(() => import('../core/modules/MapSegments'));
const UserSubModuleProcessFlows = lazy(() => import('../core/modules/ProcessFlows/list'));
const Notifications = lazy(() => import('../core/modules/notifications'));


export default function APPSRouteControls(props) {

    let userProps = {
        'AccessPortal': props.AccessPortal,
        'accessPermissions': props.accessPermissions,
        'accessLevelPermissions': props.accessLevelPermissions
    }
    let compmap = props.compmap
    const helpContext = useRef(null);
    const loaderView = React.useRef(null);
    const alertView = React.useRef(null);
    const noticeView = useRef(null)
    const confirmationView = useRef(null)

    useEffect(() => {
        if (loaderView && loaderView.current)
            DefaultSettings.setLoader(loaderView.current);
        if (alertView && alertView.current)
            DefaultSettings.setAlert(alertView.current);
        if (helpContext && helpContext.current)
            DefaultSettings.setDrawer(helpContext.current);
        if (noticeView && noticeView.current)
            DefaultSettings.setNotices(noticeView.current);
        if (confirmationView && confirmationView.current)
            DefaultSettings.setConfirmation(confirmationView.current);
    }, [loaderView, alertView, helpContext, noticeView, confirmationView])



    return (<Suspense fallback={<div className="col">
        {/* <Backdrop open={true} /> */}
        <Skeleton variant="text" width='100%' height={50} />
        <Skeleton variant="rect" width='100%' height={800} />
    </div>}>
        {/* <Router> */}
        <Loader ref={loaderView} />
        <Alert ref={alertView} />
        <HelpContext ref={helpContext} />
        <RecordEditor ref={noticeView} />
        <ConfirmationDialog ref={confirmationView} />
        <Switch>
            <Route exact strict path='/Records/:key/new' render={() => <CreateRecord {...userProps} compmap={compmap} />} />
            <Route exact strict path='/Records/:key/:routeid/:routeid1/:sidebar?/:id?' render={() => <EditRecord userProps={userProps} compmap={compmap} />} />
            <Route exact strict path='/Administration/settings/:TableName?' component={Settings} />
            <Route exact strict path='/Administration/noticestypes/:mid?' component={Notice} />
            <Route exact strict path='/Administration/masternotices/:id?' component={MasterTemplates} />
            <Route exact strict path='/Administration/sidebarbr/:id?' component={SidebarBr} />
            <Route exact strict path='/Administration/billingconfiguration/:id?' component={Billingconfiguration} />
            <Route exact strict path='/Administration/projectdownloads' component={ProjectDownloads} />
            <Route exact strict path='/Administration/holidays/:id?' component={Holidays} />
            {/* <Route exact strict path='/search' component={Search} /> */}
            <Route exact path='/advsearch' component={AdvSearch} />
            <Route exact path='/Administration/authorizations/:id?' render={() => <Authorizations />} />
            <Route exact strict path='/Administration/registrationrequest/:id?' render={() => <RegistrationRequest />} />
            <Route exact strict path='/Administration/consultants/:Id?' render={() => <CGrid compmap={compmap} components={props.components}
                {...userProps} {...consultantgrid} />} />
            <Route exact strict path='/Portal/Approvals' render={() => <CompanyApprovals />} />
            <Route exact strict path='/Administration/switchworkflow' component={SwitchWorkflow} />
            <Route exact strict path='/userprocessflowlist/:submodulekey?' component={UserSubModuleProcessFlows} />
            <Route exact strict path='/userprocessflows/:id?/:version?/:add?' component={UserProcessFlows} />
            <Route exact strict path='/userdashboardflows/:view?/:id?' component={DashboardFlowIntegrations} />
            <Route exact strict path='/smartnotifications' component={Notifications} />
            <Route exact strict path='/Dashboardflows' component={DashboardBuilder} />
            <Route exact strict path='/processflows' component={ProcessBuilder} />
            <Route exact strict path='/reports' component={ReportsBuilder} />
            <Route exact strict path='/flows' component={FormBuilder} />
            <Route exact strict path='/widgets' component={Integrations} />
            <Route exact strict path='/Administration/mapsegments' component={MapSegments} />
        </Switch>
        {/* </Router> */}
    </Suspense>
    );
}